import { jsx, jsxs } from "react/jsx-runtime";
import { IconButton, Stack, Typography } from "@mui/material";
import { AddCircle, Delete } from "../../../../../../../icons/index.js";
import { useColorPicker } from "../../../../../index.js";
import { Placeholder } from "../../../../Placeholder/Placeholder.js";
import { Swatch } from "../../../../Swatch/Swatch.js";
import { Tooltip } from "../../../../Tooltip.js";
import { Grid } from "../../Grid/Grid.js";
import { useColorGroup } from "../hooks/useColorGroup.js";
import { ColorGroupHeader } from "./ColorGroupHeader/index.js";
function ColorGroup(props) {
  const {
    id,
    colorGroup,
    maxSwatches,
    colorGroup: { label, colors }
  } = props;
  const {
    localeText,
    selection,
    placeholdersCount,
    actions: { addAction, deleteAction, onChange }
  } = useColorGroup(id, colorGroup, maxSwatches);
  const { swatchSize } = useColorPicker();
  return /* @__PURE__ */ jsxs(Stack, { "data-testid": "ColorGroup", display: "inline-flex", gap: 0.5, children: [
    /* @__PURE__ */ jsx(
      ColorGroupHeader,
      {
        label: /* @__PURE__ */ jsx(Typography, { noWrap: true, variant: "caption", children: label }),
        children: /* @__PURE__ */ jsxs(Stack, { direction: "row", flex: 0, children: [
          deleteAction.visible && /* @__PURE__ */ jsx(Tooltip, { placement: "bottom", title: localeText.deleteColorTooltip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
            IconButton,
            {
              "data-testid": "ColorGroup--Delete",
              disabled: deleteAction.disabled,
              onClick: deleteAction.onClick,
              children: /* @__PURE__ */ jsx(Delete, {})
            }
          ) }) }),
          addAction.visible && /* @__PURE__ */ jsx(
            Tooltip,
            {
              placement: "bottom",
              title: addAction.disabled ? localeText.addColorDisabledTooltip : localeText.addColorTooltip,
              children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(IconButton, { "data-testid": "ColorGroup--Add", disabled: addAction.disabled, onClick: addAction.onClick, children: /* @__PURE__ */ jsx(AddCircle, {}) }) })
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsxs(Grid, { testId: "ColorGroup--Grid", children: [
      colors.map((color) => /* @__PURE__ */ jsx(
        Swatch,
        {
          color,
          localeText,
          onSelect: onChange,
          selected: selection.has(color),
          swatchSize
        },
        color
      )),
      Array.from({ length: placeholdersCount }).map((_, idx) => /* @__PURE__ */ jsx(
        Placeholder,
        {
          disabled: addAction.disabled,
          onClick: addAction.onClick,
          swatchSize,
          tooltip: addAction.disabled ? localeText.addColorDisabledTooltip : localeText.addColorTooltip
        },
        idx
      ))
    ] })
  ] }, id);
}
export {
  ColorGroup
};
//# sourceMappingURL=ColorGroup.js.map
